import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./router";

const App: React.FC = () => {
  // Ensure Tailwind's dark mode is active
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return <RouterProvider router={router} />;
};

export default App;
